import { defineStore } from "pinia"
import { membershipKeyList, expireDateKeyList } from "~/constants/common"
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from "lodash/isEmpty"

export const useCompanyStore = defineStore("company", () => {
  const { locale } = useI18n()
  const allSupplier = ref([])
  const allSupplierCount = ref(0)
  const priority = ref([])
  const company = ref({})
  const totalPubicBook = ref(0)
  const totalPubicYarnBook = ref(0)
  const totalPubicColor = ref(0)
  const totalWaitingApproval = ref(0)
  const baseStore = useBaseStore()
  const companyFormValue = ref(null);
  const supplierAllForAccount = ref({})
  const allSupplierCountForAccount = ref(0)
  const userOnlyCountries = ref([])
  const statusReceive = ref(null)
  const listMail = ref([])
  const blockDownloadForm = ref({})
  const blockList = ref([])
  const totalBlockDownload = ref(0)
  
  const DEFAULT_TAB_VALUE = 'All'
  const companyListWithAlphabetOrigin = ref([
    { value: DEFAULT_TAB_VALUE, text: "All", list: [] },
    { value: "A", text: "A", list: [] },
    { value: "B", text: "B", list: [] },
    { value: "C", text: "C", list: [] },
    { value: "D", text: "D", list: [] },
    { value: "E", text: "E", list: [] },
    { value: "F", text: "F", list: [] },
    { value: "G", text: "G", list: [] },
    { value: "H", text: "H", list: [] },
    { value: "I", text: "I", list: [] },
    { value: "J", text: "J", list: [] },
    { value: "K", text: "K", list: [] },
    { value: "L", text: "L", list: [] },
    { value: "M", text: "M", list: [] },
    { value: "N", text: "N", list: [] },
    { value: "O", text: "O", list: [] },
    { value: "P", text: "P", list: [] },
    { value: "Q", text: "Q", list: [] },
    { value: "R", text: "R", list: [] },
    { value: "S", text: "S", list: [] },
    { value: "T", text: "T", list: [] },
    { value: "U", text: "U", list: [] },
    { value: "V", text: "V", list: [] },
    { value: "W", text: "W", list: [] },
    { value: "X", text: "X", list: [] },
    { value: "Y", text: "Y", list: [] },
    { value: "Z", text: "Z", list: [] },
    { value: "Others", text: "Others", list: [] },
  ]);
  const selectedAlphabetIndex = ref(0);
  const companyProfile = ref({
    profileImages: [
      { seq: 1, imgPath: '', imgData: '', imgName: '' },
      { seq: 2, imgPath: '', imgData: '', imgName: '' }
    ],
    profileText: [
      { seq: 0, locale: 'en', text: '' },
      { seq: 0, locale: 'ja', text: '' },
      { seq: 0, locale: 'zh', text: '' }
    ]
  })
  
  const defaultTemplate = {
    profileImages: [
      { seq: 1, imgPath: '', imgData: '', imgName: '' },
      { seq: 2, imgPath: '', imgData: '', imgName: '' }
    ],
    profileText: [
      { seq: 0, locale: 'en', text: '' },
      { seq: 0, locale: 'ja', text: '' },
      { seq: 0, locale: 'zh', text: '' }
    ]
  }
  
  const propertyMap = {
    img_path: 'imgPath',
    img_data: 'imgData',
    img_name: 'imgName',
    profile_text: 'text',
    image_url: 'imgPath'
  }

  const getSupplierAll = async ({ showSpinner, refresh, ...rest }) => {
    return apiWrapper(async () => {
      if (!refresh && allSupplier.value.length) {
        return {
          allSupplier: cloneDeep(allSupplier.value),
          totalCount: allSupplierCount.value
        }
      }
      showSpinner && baseStore.setSpinner()

      const { data } = await usePost('/company/q/s', { locale: locale.value, ...rest })
      allSupplier.value = data.data.data
      allSupplierCount.value = data.data.totalCount
      totalPubicBook.value = data.data.totalPubicBook
      totalPubicYarnBook.value = data.data.totalPubicYarnBook
      totalPubicColor.value = data.data.totalPubicColor
      totalWaitingApproval.value = data.data.totalWaitingApproval

      showSpinner && baseStore.hideSpinner()
      return {
        allSupplier: cloneDeep(allSupplier.value),
        totalCount: allSupplierCount.value
      }
    })
  }

  const getAllCompanyName = () => {
    return allSupplier.value.map(({ companyName }) => {
      return companyName;
    });
  };

  const getCompanyPriority = async () => {
    const {
      data: { data: priority },
    } = await usePost("/company/priority/q/a", {
      locale: locale.value,
    });
    priority.value = priority;
    return priority;
  };

  const contactSupplier = ({
    subjectText,
    askMessage,
    yarnlogId,
    typeEnquiry,
    skipNotification,
  }) => {
    return apiWrapper(async () => {
      const {
        data: { data },
      } = await usePost(`/mail/supplier/i`, {
        subjectText,
        skipNotification,
        askMessage,
        yarnlogId,
        typeEnquiry,
      });
      return data;
    });
  };
  
  const contactCompanySupplier = ({
    subjectText,
    askMessage,
    companyId,
    typeEnquiry,
    skipNotification,
  }) => {
    return apiWrapper(async () => {
      const {
        data: { data },
      } = await usePost(`/mail/supplier/i`, {
        subjectText,
        skipNotification,
        askMessage,
        companyId,
        typeEnquiry
      });
      return data;
    });
  };
  
  const inquiryYarn = (params) => {
    return apiWrapper(async () => {
      // Receive FormData containing both text fields and image files
      const { data } = await usePost(`/mail/yarn/i`, params);
      return data.data;
    });
  };
  
  const getCompanyProfileDetail = async ({ companyId }) => {
    const {
      data: { data },
    } = await usePost("/company/profile/q", {
      companyId,
    });

    const defaultItalianTemplate = [
      { seq: 0, locale: "en", text: "" },
      { seq: 0, locale: "ja", text: "" },
      { seq: 0, locale: "it", text: "" },
      { seq: 0, locale: "zh", text: "" },
    ];

    profilePropertyMap(data);
    const resultProfileText = mergeArraysByKey(
      defaultItalianTemplate,
      data.profileText,
      "locale"
    );
    const resultProfileImages = mergeArraysByKey(
      defaultTemplate.profileImages,
      data.profileImages,
      "seq"
    );
    const result = {
      profileText: resultProfileText,
      profileImages: resultProfileImages,
    };
    //always have default of 2 image fields & 4 text fields, but then add/replace values from backend
    companyProfile.value = result;
    return result;
  };

  const profilePropertyMap = (data) => {
    for (let profileField in data) {
      if (
        typeof data[profileField] === typeof [] &&
        data[profileField].length > 0
      ) {
        Object.keys(data[profileField][0]).map((key, index) => {
          const oldKey = key;
          if (propertyMap[oldKey]) {
            const newKey = propertyMap[oldKey];
            for (let i = 0; i < data[profileField].length; i++) {
              const obj = data[profileField][i];
              delete Object.assign(obj, { [newKey]: obj[oldKey] })[oldKey];
            }
          }
        });
      }
    }
  };

  const setCompany = (companyData) => {
    company.value = companyData;
  };

  const setSelectedAlphabetIndex = (index) => {
    selectedAlphabetIndex.value = index;
  };

  const getStorageCapacity = async (params) => {
    const response = await usePost("/storagecap", params);
    return response.data.data;
  };

  const checkCompanyName = async (companyName) => {
    const result = await usePost(`/company/q/name`, {
      companyName,
    });
    return result.data.data.isExist;
  };

  const getCompanyProfile = ({ companyId }) => {
    return apiWrapper(async () => {
      const resultProfile = await usePost(
        '/company/profile/q',
        {
          companyId
        }
      )

      profilePropertyMap(resultProfile.data.data);
      const resultProfileText = mergeArraysByKey(
        defaultTemplate.profileText,
        resultProfile.data.data.profileText,
        "locale"
      );
      const resultProfileImages = mergeArraysByKey(
        defaultTemplate.profileImages,
        resultProfile.data.data.profileImages,
        "seq"
      );
      const result = {
        profileText: resultProfileText,
        profileImages: resultProfileImages,
      };
      //always have default of 2 image fields & 4 text fields, but then add/replace values from backend
      companyProfile.value = result;
      return result;
    });
  };
  
  const updateCompany = (params) => {
    return apiWrapper(async () => {
      const result = await usePost(
        `/company/u`,
        params
      )

      if (params.updateCompanyPlan) {
        await usePost(
          `/company/u/p`,
          {
            skipNotification: params.skipNotification,
            companyId: params.companyId,
            emailLimit:params.emailLimit,
            planId: params.planId,
            addStorage: params.addStorage,
            expireDate: expireDateKeyList
              .map(key => {
                return params[key]
              })
              .join('-'),
            confirmDate: membershipKeyList
              .map(key => {
                return params[key]
              })
              .join('-')
          }
        )
      }
      return result.data.data
    })
  }
  
  const createCompany = async (params) => {
    const result = await usePost('/company/i', {...params})
    return result.data.status
  }
  
  const updateCompanyProfile = ({ companyId, ...rest }) => {
    const mappedObj = { ...rest };
    profilePropertyMap(mappedObj);
    return apiWrapper(async () => {
      const { data } = await usePost(
        `/company/profile/u`,
        { ...mappedObj, companyId, locale: locale.value }
      )

      const resultProfileText = mergeArraysByKey(defaultTemplate.profileText, data.data.profileText, 'locale');
      const resultProfileImages = mergeArraysByKey(defaultTemplate.profileImages, data.data.profileImages, 'seq');
      const result = {
        profileText: resultProfileText,
        profileImages: resultProfileImages
      }
      companyProfile.value = result
      return result
    })
  }

  const getSupplierAllForAccount = async (locale) => {
    return apiWrapper(async () => {
      baseStore.setSpinner()

      const { data } = await usePost('/company/q/s/list', {
        locale
      })

      const result = data.data.map(({ company_id, company_name, ...rest }) => ({
        ...rest,
        companyName: company_name,
        companyId: company_id,
      }))

      supplierAllForAccount.value = result
      allSupplierCountForAccount.value = data.totalCount || result.length

      baseStore.hideSpinner()

      return {
        suppliers: cloneDeep(supplierAllForAccount.value),
        totalCount: allSupplierCountForAccount.value,
      }
    })
  }

  const fetchUserOnlyCountry = async (locale) => {
    return apiWrapper(async () => {
      const response = await callPostWithToken(
        '/company/q/s/country',
        { locale }
      )

      const { data } = response.data

      userOnlyCountries.value = data.map(({ countryCode, countryName, ...rest }) => ({
        value: countryCode,
        text: countryName,
        ...rest
      }))
      return data
    })
  }

  const getUserOnlyCountries = (optionalOption) => {
    return [optionalOption, ...userOnlyCountries.value].filter(n => n)
  }

  // const checkCompanyName = (companyName) => {
  //   return apiWrapper(async () => {
  //     const { data } = await usePost('/company/q/name', { companyName })
  //     return data.isExist
  //   })
  // }

  const withdrawCompany = async (params) => {
    return apiWrapper(async () => {
      const response = await callPostWithToken(
        '/company/d',
        params
      )

      const { data } = response.data
      return data
    })
  }

  const showHideCompany = async (params) => {
    return apiWrapper(async () => {
      const response = await callPostWithToken(
        '/company/u/af',
        params
      )

      const { data } = response.data
      return data
    })
  }
  
  const getCountriesByLocale = async ({ locale }) => {
    const result = await usePost(
      '/country/q/a',
      {
        countryName: '%',
        locale
      }
    )
    return result.data.data
  }

  const getCompany = ({ companyId, contractInfo }) => {
    return apiWrapper(async () => {
      let contractInfoFromServer = {}

      const res = await usePost('/company/q', { companyId, locale: locale.value })

      if (isEmpty(res.data.data)) {
        company.value = { notExist: true }
        return
      }

      const bookRes = await usePost('/company/q/b', { companyId })
      if (contractInfo) {
        const { data } = await usePost('/company/q/p', { companyId, locale: locale.value })
        contractInfoFromServer = data.data
        contractInfoFromServer.confirmDate &&
          contractInfoFromServer.confirmDate
            .split('-')
            .forEach((date, index) => {
              contractInfoFromServer[membershipKeyList[index]] = Number(date)
            })
        contractInfoFromServer.expireDate &&
          contractInfoFromServer.expireDate
            .split('-')
            .forEach((date, index) => {
              contractInfoFromServer[expireDateKeyList[index]] = Number(date)
            })
      }
      const result = {
        ...contractInfoFromServer,
        ...res.data.data,
        ...bookRes.data.data,
      }
      company.value = result
      return result
    })
  }
  
  const updateStopReceive = async (params) => {
    const result = await usePost(`/company/u/s/r`, {
      stopReceive: params.stopReceive,
      userId: params.userId,
    });
    return result.data.data;
  };
  
  const updateListCompanySendMail = async (params) => {
    const result = await usePost(`/company/u/s/m`, {
      companyMail: params.companyMail,
    });
    return result.data.data;
  };

  const getStopReceive = () => {
    return apiWrapper(async () => {
      const res = await usePost(`/company/g/s/r`, { locale: locale.value });
      statusReceive.value = res.data.data.stopReceive;
      return res.data.data.stopReceive;
    });
  };
  
  const getListMail = async () => {
    baseStore.setSpinner();
    const res = await usePost(`/company/q/u/a`, {
      locale: locale.value,
    });
    listMail.value = res.data.data;
    baseStore.hideSpinner();
    return res.data.data;
  };

  const getBlockList = async (params) => {
    const result = await usePost('/company/block/q/a', params)
    blockList.value = result.data.data.data
    totalBlockDownload.value = result.data.data.total.totalCount
  }

  const blockDownload = async (params) => {
    const result = await usePost('/company/block/i', params)
    return result.data.data
  }

  const getBlockDownload = async (params) => {
    const result = await usePost('/company/block/q', params)
    return result.data.data
  }

  const updateBlockDownload = async (params) => {
    const result = await usePost('/company/block/u', params)
    return result.data.data
  }

  const removeBlockDownload = async (id) => {
    const result = await usePost('/company/block/d', id)
    return result.data.data
  }

  return {
    allSupplier,
    priority,
    allSupplierCount,
    totalPubicBook,
    totalPubicYarnBook,
    totalWaitingApproval,
    totalPubicColor,
    getSupplierAll,
    getAllCompanyName,
    getCompanyPriority,
    company,
    contactSupplier,
    companyListWithAlphabetOrigin,
    setSelectedAlphabetIndex,
    selectedAlphabetIndex,
    contactCompanySupplier,
    companyProfile,
    getCompanyProfileDetail,
    setCompany,
    getStorageCapacity,
    checkCompanyName,
    getCompanyProfile,
    companyFormValue,
    updateCompany,
    createCompany,
    updateCompanyProfile,
    supplierAllForAccount,
    allSupplierCountForAccount,
    getSupplierAllForAccount,
    fetchUserOnlyCountry,
    getUserOnlyCountries,
    withdrawCompany,
    showHideCompany,
    getCountriesByLocale,
    getCompany,
    statusReceive,
    listMail,
    blockDownloadForm,
    blockList,
    totalBlockDownload,
    updateStopReceive,
    updateListCompanySendMail,
    getStopReceive,
    getListMail,
    getBlockList,
    blockDownload,
    getBlockDownload,
    updateBlockDownload,
    removeBlockDownload,
    inquiryYarn
  }
})